import { Item, Option } from '@/types/common';
import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';

export const getMappedOptionsForUsualSelect = (data: Item[]): Option[] => {
  return data.map((item) => ({
    value: item.value,
    label: item.name,
  }));
};

export const getFormattedDateFromFormDateFieldValue = (value: Dayjs) => {
  return value.format('YYYY-MM-DDT00:00:00.000[Z]');
};

dayjs.extend(utc);

export const getFormFieldValueFromObjectKeyValue = (key: string, value: any, fieldValueMustBeAnArray?: boolean) => {
  let inputValue;

  if (key.includes('date') && typeof value === 'string') inputValue = dayjs.utc(value);
  else if (typeof value === 'string' && fieldValueMustBeAnArray)
    inputValue = value.split(',').map((value) => value.trim());
  else if (value === 0 || value === 1) inputValue = !!value;
  else inputValue = value;

  return inputValue;
};

export const checkIsFormValuesChanged = <T extends Record<string, any>>(
  initialValues: Partial<T>,
  currentValues: T,
) => {
  return !Object.entries(currentValues).every(([key, value]) => {
    if (dayjs.isDayjs(value) && dayjs.isDayjs(initialValues[key])) {
      return value.isSame(initialValues[key], 'day');
    } else if (value === '') {
      return initialValues[key] === undefined || initialValues[key] === '';
    } else if (Array.isArray(value)) {
      if (value.length) {
        return value.length === initialValues[key]?.length && value.every((item) => initialValues[key]?.includes(item));
      } else {
        return initialValues[key] === undefined || (Array.isArray(initialValues[key]) && !initialValues[key]?.length);
      }
    } else {
      return JSON.stringify(value) === JSON.stringify(initialValues[key]);
    }
  });
};

export const getFormSearchableSelectInitialItems = (
  connectedIdKey: string,
  connectedIdKeyValue: string,
  value: string,
  separator: string,
) => {
  let selectedItems: Item[];

  if (connectedIdKey.includes('ids')) {
    selectedItems = connectedIdKeyValue.split(',').map((id, index) => {
      return {
        value: id.trim(),
        name: value.split(separator)[index].trim(),
      };
    });
  } else {
    selectedItems = [
      {
        value: connectedIdKeyValue,
        name: value,
      },
    ];
  }

  return selectedItems;
};
